import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-76954176"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "zoom" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-compress" }, null, -1))
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-search-plus" }, null, -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = ["max", "value"]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-search-minus" }, null, -1))
const _hoisted_8 = [
  _hoisted_7
]

import { gridSizeList } from "@/library/hardCodedValues";
import { useCoordinateStore } from "@/stores/coordinate";

export default /*#__PURE__*/_defineComponent({
  __name: 'ZoomPanel',
  setup(__props) {

const coordinate = useCoordinateStore();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "zoom_icon",
      title: "Reset view",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(coordinate).resetView && _unref(coordinate).resetView(...args)))
    }, _hoisted_3),
    _createElementVNode("div", {
      class: "zoom_icon",
      title: "Zoom in",
      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_unref(coordinate).zoomIn && _unref(coordinate).zoomIn(...args)))
    }, _hoisted_5),
    _createElementVNode("input", {
      type: "range",
      id: "zoom_range",
      title: "zoom",
      name: "zoom",
      min: "0",
      max: _unref(gridSizeList).length - 1,
      value: _unref(coordinate).zoomIdx,
      disabled: "true",
      orient: "vertical"
    }, null, 8, _hoisted_6),
    _createElementVNode("div", {
      class: "zoom_icon",
      title: "Zoom out",
      onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_unref(coordinate).zoomOut && _unref(coordinate).zoomOut(...args)))
    }, _hoisted_8)
  ]))
}
}

})